'use strict';

jQuery(function ($) {

    $(document).ready(function () {
        var sliderInit = {
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: false,
            infinite: false,
            responsive: [{
                breakpoint: 99999,
                settings: 'unslick'
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }]
        };

        var productSliderInit = {
            dots: true,
            autoplay: false,
            infinite: false,
            responsive: [{
                breakpoint: 99999,
                settings: 'unslick'
            }, {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        };

        $('#mobileImageSlider').slick(productSliderInit);

        $('#world-of-mny__list, #popular-products__list, #best-seller-products, #productRecommendation').slick(sliderInit);

        function moveSelect() {
            if ($(window).width() < 768) {
                $('.sort-select__wrapp').insertAfter('.product-filters');
            } else {
                $('.sort-select__wrapp').insertAfter('.filter-btn__wrapp');
            }
        }

        moveSelect();

        if ($(window).width() < 991) {
            $('.nav-item:has(.nav-submenu)').addClass('has-child');
        }

        $('#nav-mobile-hamburger').click(function () {
            var mobileSidebar = document.getElementById('mobileSidebar');
            $(this).toggleClass('open');
            $(mobileSidebar).toggleClass('show');
            $('body').toggleClass('overflow');
        });

        $('.nav-link').click(function (e) {
            if ($(window).width() < 991 && $(this).parent().hasClass('has-child')) {
                e.preventDefault();
                $(this).parent().toggleClass('open');
                $(this).siblings('.nav-submenu').toggle();
            }
        });

        $('.select').selectpicker();

        $('.js-accordion-item').click(function () {
            if ($(this).hasClass('open')) {
                $(this).children('.accordion__main').slideUp();
                $(this).removeClass('open');
            } else {
                $('.accordion__main').slideUp();
                $(this).children('.accordion__main').slideDown();
                $('.js-accordion-item').removeClass('open');
                $(this).addClass('open');
            }
        });

        $('#filterBtn').click(function () {
            if ($(window).width() > 768) {
                $('.product-filters').toggleClass('hide');
                $('.product-list').toggleClass('col-md-12');
                $('.product-list__item').toggleClass('col-md-3 col-md-4');
                $('#filterBtn').toggleClass('closed');
            } else {
                $('.product-filters').slideToggle();
                $('#filterBtn').toggleClass('open');
            }
        });

        $('.quantity-decrease-btn').click(function () {
            var $input = $(this).parent().find('input');
            var count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count);
            $input.change();
            return false;
        });
        $('.quantity-increase-btn').click(function () {
            var $input = $(this).parent().find('input');
            $input.val(parseInt($input.val()) + 1);
            $input.change();
            return false;
        });

        $('.leftSidebar, .rightSidebar').theiaStickySidebar({
            'additionalMarginTop': 120,
            'additionalMarginBottom': 20
        });

        function showCart() {
            $('#shoppingCart').mousemove(function () {
                $('#smallBasket').fadeIn(300);
            });

            //$('.navbar-nav__icons').mouseleave(function () {
              //  $('#smallBasket').hide();
            //});
        }

        showCart();

        $('.collapsible').click(function () {
            if ($(this).hasClass('open')) {
                $('.collapsible').removeClass('open');
            } else {
                $('.collapsible').removeClass('open');
                $(this).addClass('open');
            }
        });

        function initZoomImage() {
            if ($(window).width() > 991) {
                $('.zoom-image-big').elevateZoom({
                    cursor: 'pointer',
                    galleryActiveClass: 'active',
                    borderColour: '#eee',
                    borderSize: '1'
                });
            } else {
                $('.zoomContainer').remove();
            }
        }

        initZoomImage();

        function setActiveThumbnail() {
            var bigImages = document.querySelectorAll('.zoom-image-big');
            $(bigImages).each(function () {
                var imageId = $(this).attr('id');
                if ($('#' + imageId).visible(true, false, 'both')) {
                    $('.thumbnail').removeClass('activeThumbnail');
                    $('#thumbnail_' + imageId).addClass('activeThumbnail');
                }
            });
        }

        // Call Fancybox globally on all elemnets with class "fancybox"
        $('.quick-view-btn').fancybox({
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });

        setActiveThumbnail();

        $(document).scroll(function () {
            setActiveThumbnail();
        });

        $(window).resize(function () {
            $('#world-of-mny__list, #popular-products__list, #best-seller-products, #productRecommendation').slick(sliderInit);
            $('#mobileImageSlider').slick(productSliderInit);

            moveSelect();
            initZoomImage();

            if ($(window).width() > 768) {
                $('.product-filters').removeAttr('style');
            }
        });
    });
});